import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'antd';

import { ModalSto } from '../sto';

const AccountCreatedModal = (props) => (
    <ModalSto
        buttonSize="large"
        icon="check"
        isCTA={true}
        modalType="accountCreated"
        okText="pages.button.login"
        onOk={props.onOk}
        visible={props.visible}
        wrapClassName="account-validated-modal"
    >
        <React.Fragment>
            <Icon type="check-circle" />
            <p id="popup.registration">
                <FormattedMessage id="pages.registration.step3.accountcreated" />
            </p>
        </React.Fragment>
    </ModalSto>
);

export default AccountCreatedModal;
